// src/components/CustomerLogin.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/client';
import { trackLogin } from '../utils/analytics';
import './AuthForm.css'; // ✅ use shared CSS

const CustomerLogin = ({ onLogin }) => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = form;
    if (!email || !password) {
      setError('Please fill in both fields');
      return;
    }

    try {
  const res = await api.post(`/api/customers/login`, { email, password });
  const { token, customer } = res.data;

  const unified = {
    id: customer._id || customer.id,   // <-- supports both _id and id
    name: customer.name,
    email: customer.email,
    phone: customer.phone,
    token, // token is already a string
  };

  localStorage.setItem('customer', JSON.stringify(unified));
  console.log("✅ Saved customer:", unified); // <-- debug log

  if (onLogin) onLogin(unified);
  trackLogin("email");

  const redirectTo = sessionStorage.getItem('redirectAfterLogin');
  sessionStorage.removeItem('redirectAfterLogin');
  navigate(redirectTo === 'checkout' ? '/checkout' : '/');
} catch (err) {

      console.error('Login error:', err);
      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Invalid credentials';
      setError(msg);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Customer Login</h2>

      {error && <div className="message error">{error}</div>}

      <input
        name="email"
        type="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
      />
      <input
        name="password"
        type="password"
        placeholder="Password"
        value={form.password}
        onChange={handleChange}
        required
      />

      <Link to="/forgot-password" style={{ fontSize: '14px', color: '#007bff' }}>
        Forgot Password?
      </Link>

      <button type="submit">Login</button>
    </form>
  );
};

export default CustomerLogin;
